import dashboardReducer from "./reducer/dashboardSlice";
import dataReducer from "./reducer/dataSlice";

import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
    PersistConfig,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import themeSettingsReducer from "./reducer/themeSettingSlice";
import { useDispatch } from "react-redux";

const rootReducer = combineReducers({
    dashboard: dashboardReducer,
    data: dataReducer,
    themeSettings: themeSettingsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

// Type-safe persist config
const persistConfig: PersistConfig<RootState> = {
    key: "root",
    version: 1,
    storage,
    whitelist: ["themeSettings"], // Only persist themeSettings slice
    // Don't persist CRM data as it should be fetched from backend
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
    devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export default store;

export const useAppDispatch = () => useDispatch<AppDispatch>();
